/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import {
  SAButton,
  SACard,
  SAIcon,
  SAIcons,
  SATag,
  SAText,
} from '@saux/design-system-react';
import AWSAppSyncClient from 'aws-appsync';
import React, { useEffect, useRef, useState } from 'react';
// eslint-disable-next-line import/no-cycle
import { ChangeDueDateModal, MakePaymentModal, StopPaymentButton } from '..';
import {
  GET_ACCOUNT_INVOICES_invoices_items,
  GET_PAYMENT_INFO,
} from '../../generated/GET_PAYMENT_INFO';
import { formatDate, formatMoney } from '../../util/formatters';
import customBase from '../../util/global.theme';
import { simpleGTMDataLayer } from '../../util/GTMHelpers';
import useMultipleFeatureFlags from '../../util/hooks/useMultipleFeatureFlags';
import generateOpenOneIncURL from '../../util/openOneIncURL/generateOpenOneIncURL';
import useIsResponsive from '../../util/useIsResponsive';
import OutageModal from '../outageModal/OutageModal';
import StopPaymentModalDC from '../stopPaymentModal';
import { ResponsiveTooltip } from '../stopPaymentTooltips';
import { ToolTip } from '../stopPaymentTooltips/DesktopTooltip';
import {
  AmountAndButtonWrapper,
  AmountDue,
  AmountDueWrapper,
  Border,
  DesktopButtonWrapper,
  DesktopScheduleTextHolder,
  DueDate,
  LastDayToPaySpacer,
  LastDayToPayText,
  LastPaymentWrapper,
  MakePaymentButtonSpacer,
  MakePaymentButtonWrapper,
  MobileScheduleTextHolder,
  MortgageePaymentWordingText,
  NextPaymentWrapper,
  NextPaymentWrapperError,
  PastDueCard,
  PastDueIndicator,
  ReceivedOnWrapper,
  ResponsiveButtonWrapper,
} from './NextPaymentStyles';
import { ReactComponent as GreenCheck } from '../../assets/images/check.svg';
import { useFeatureFlag } from '../../util/hooks';

interface LastDayToPayInfoProps {
  showLastDayToPay: boolean;
  pastDueAmount: string | null;
  date: Date | string | null;
}

interface DisclaimerProps {
  baseState: string | '';
  showDisclaimer: boolean
}

export interface NextPaymentProps {
  showPastDue: boolean;
  paymentInfo?: PaymentInformation | any;
  awsAppSyncClient: AWSAppSyncClient<any>;
  accountNumber: string;
  loading?: boolean;
  error?: Error;
  onlyMortgageeBilledInvoices: boolean;
  mortgageeInvoice: GET_ACCOUNT_INVOICES_invoices_items | null;
  setReRenderComponentAfterChangedDueDate: Function;
  sourceSystemCode: string;
  displayStopPaymentButton?: boolean;
  lastDayToPayInfo: LastDayToPayInfoProps;
  isMigrated: boolean;
}

export interface PaymentInformation {
  paymentAmount: string;
  paymentDueDate: string | Date | number | null | undefined;
  pastDueAmount: string;
  showDisclaimer: DisclaimerProps;
  responsiveIndicator: string;
  defaultBillingMethod: string;
  lastPaymentAmount: string;
  lastPaymentDate: string;
}

export interface UpcomingPaymentInfoProps {
  paymentAmount: string;
  paymentInfo: PaymentInformation | any;
  hasStoppedPayment: boolean;
  showPastDue: boolean;
  onlyMortgageeBilledInvoices: boolean;
  mortgageeInvoice: GET_ACCOUNT_INVOICES_invoices_items | null;
  showLastDayToPay: boolean;
}

export interface Invoices {
  due_date: string | null;
  invoice_amount: number | null;
  invoice_key: string | null;
  mortgagee_flag: string | null;
}

export function makeNextPaymentClick(
  paymentInfo: GET_PAYMENT_INFO | any,
  accountNumber: string,
  awsAppSyncClient: AWSAppSyncClient<any>,
  SSOneINCURL?: boolean | null,
) {
  const userId: string | undefined = paymentInfo?.me?.user_id;
  generateOpenOneIncURL(
    awsAppSyncClient,
    accountNumber,
    userId,
    SSOneINCURL,
    sessionStorage?.userLOB?.includes('Commercial') ? 'GWCL' : 'GWPL',
  );
}

export const UpcomingPaymentInfo: Function = ({
  paymentInfo,
  hasStoppedPayment,
  showPastDue,
  onlyMortgageeBilledInvoices,
  mortgageeInvoice,
  showLastDayToPay,
}: UpcomingPaymentInfoProps) => {
  if (
    paymentInfo?.paymentAmount === 'PAID IN FULL' &&
    !onlyMortgageeBilledInvoices
  ) {
    return (
      <>
        <AmountDue>Paid In Full</AmountDue>
      </>
    );
  }

  if (onlyMortgageeBilledInvoices && !showLastDayToPay) {
    if (!parseFloat(mortgageeInvoice?.amount_due ?? '0')) {
      return (
        <>
          <AmountDue>Paid In Full</AmountDue>
        </>
      );
    }

    return (
      <MortgageePaymentWordingText>
        <SAText
          text={`${formatMoney(mortgageeInvoice?.amount_due ?? '-')}\u00A0`}
          weight="bold"
          type="standard"
        />
        <SAText
          text={`has been billed to the mortgage company and ${
            mortgageeInvoice?.due_date &&
            new Date(mortgageeInvoice?.due_date).getTime() >
              new Date().getTime()
              ? 'is'
              : 'was'
          } due on`}
          weight="normal"
          type="standard"
        />
        <SAText
          text={`\u00A0${formatDate(mortgageeInvoice?.due_date ?? '-')}`}
          weight="bold"
          type="standard"
        />
        <SAText text="." weight="normal" type="standard" />
      </MortgageePaymentWordingText>
    );
  }
  if (
    paymentInfo?.responsiveIndicator &&
    paymentInfo?.responsiveIndicator?.toLowerCase() === 'no' &&
    hasStoppedPayment === false &&
    paymentInfo?.defaultBillingMethod?.toUpperCase() !== 'RESPONSIVE' &&
    !showPastDue &&
    paymentInfo?.paymentDueDate !== '-' &&
    !showLastDayToPay
  ) {
    return (
      <>
        <AmountDue>{paymentInfo?.paymentAmount ?? '-'}</AmountDue>
        <DesktopScheduleTextHolder>
          <SAText
            weight="bold"
            type="small"
            text="Scheduled for automatic draft"
          />
        </DesktopScheduleTextHolder>
        <MobileScheduleTextHolder>
          <SAText
            weight="bold"
            type="standard"
            text="Scheduled for automatic draft"
          />
        </MobileScheduleTextHolder>
        <DueDate>{`on ${paymentInfo?.paymentDueDate}`}</DueDate>
      </>
    );
  }
  if (
    paymentInfo?.paymentDueDate !== '-' &&
    paymentInfo?.responsiveIndicator &&
    paymentInfo?.responsiveIndicator?.toLowerCase() === 'no' &&
    paymentInfo?.defaultBillingMethod?.toUpperCase() !== 'RESPONSIVE' &&
    hasStoppedPayment === true &&
    !showPastDue &&
    !showLastDayToPay
  ) {
    return (
      <>
        <AmountDue>{paymentInfo?.paymentAmount ?? '-'}</AmountDue>
        <DueDate>{`by ${paymentInfo?.paymentDueDate}`}</DueDate>
      </>
    );
  }
  if (
    ((paymentInfo?.responsiveIndicator &&
      paymentInfo?.responsiveIndicator?.toLowerCase() === 'yes') ||
      paymentInfo?.defaultBillingMethod?.toUpperCase() === 'RESPONSIVE') &&
    !showPastDue &&
    paymentInfo?.paymentDueDate !== '-' &&
    !showLastDayToPay
  ) {
    return (
      <>
        <AmountDue>{paymentInfo?.paymentAmount ?? '-'}</AmountDue>
        <DueDate>{`by ${paymentInfo?.paymentDueDate}`}</DueDate>
      </>
    );
  }
  return (
    <>
      <AmountDue>{paymentInfo?.paymentAmount ?? '$0.00'}</AmountDue>
    </>
  );
};

const NextPayment = ({
  accountNumber,
  paymentInfo,
  awsAppSyncClient,
  showPastDue,
  loading,
  error,
  onlyMortgageeBilledInvoices,
  mortgageeInvoice,
  setReRenderComponentAfterChangedDueDate,
  sourceSystemCode,
  displayStopPaymentButton,
  lastDayToPayInfo,
  isMigrated,
}: NextPaymentProps) => {
  const [showDisclaimerModal, setShowDisclaimerModal] =
    useState<boolean>(false);
  const [baseState, setBaseState] = useState<string>(
    '',
  );
  const [showStopPaymentModal, setShowStopPaymentModal] = useState<boolean>(
    displayStopPaymentButton ?? false,
  );
  const [showChangeDueDateModal, setShowChangeDueDateModal] =
    useState<boolean>(false);
  const [showOutageModal, setShowOutageModal] = useState<boolean>(false);
  const [showToolTip, setShowToolTip] = useState<boolean>(false);
  const [hasStoppedPayment, setHasStoppedPayment] = useState<boolean>(false);
  const [cancelPaymentDisabled, setCancelPaymentDisabled] =
    useState<boolean>(false);
  const [whichComponent, setWhichComponent] =
    useState<string>('Making a Payment');
  const toolTip = useRef<ToolTip>({ title: '', subtitle: '' });
  const featureFlagDetails = useMultipleFeatureFlags([
    'StopPaymentButton',
    'ChangeDueDate',
    'BillingCenterOutage',
    'LastDayToPay',
  ]);
  const { flagDetails: SSOneINCURL } = useFeatureFlag(
    'OneINCSelfServiceMuleURL',
  );

  const isResponsive = useIsResponsive();

  useEffect(() => {
    if (
      showDisclaimerModal ||
      showStopPaymentModal ||
      showChangeDueDateModal ||
      showOutageModal
    ) {
      document.body.style.overflow = 'hidden';
    } else if (
      !showDisclaimerModal &&
      !showStopPaymentModal &&
      !showChangeDueDateModal &&
      !showOutageModal
    ) {
      document.body.style.overflow = 'auto';
    }
  }, [
    showDisclaimerModal,
    showStopPaymentModal,
    showChangeDueDateModal,
    showOutageModal,
  ]);

  const actionLabelClickHandler = () => {
    if (
      featureFlagDetails[1]?.flagDetails?.enabled &&
      paymentInfo?.paymentDueDate !== '-'
    ) {
      if (featureFlagDetails[2]?.flagDetails?.enabled) {
        setWhichComponent('Change Payment Due Date');
        setShowOutageModal(true);
      } else setShowChangeDueDateModal(true);
    } else
      makeNextPaymentClick(
        paymentInfo,
        accountNumber,
        awsAppSyncClient,
        SSOneINCURL?.enabled,
      );
    simpleGTMDataLayer({
      event: 'BillingPayments-ChangeDueDate-click',
      event_action: 'Billing Payments Change Due Date Click',
      event_category: 'Billing Payments Change Due Date',
      event_label: 'Billing Payments Change Due Date Click',
    });
    simpleGTMDataLayer({
      event: 'Snowplow-BillingPayments-ChangeDueDate-click',
      event_action: 'Snowplow Billing Payments Change Due Date Click',
      event_category: 'Snowplow Billing Payments Change Due Date',
      event_label: 'Snowplow Billing Payments Change Due Date Click',
    });
  };

  if (loading) {
    return (
      <SACard
        data-test-id="next-payment-card-billing-page"
        variant="standard"
        title="Next Payment"
      >
        <NextPaymentWrapperError>
          <SAText type="standard" text="Loading..." />
        </NextPaymentWrapperError>
      </SACard>
    );
  }

  if (error) {
    return (
      <SACard
        data-test-id="next-payment-card-billing-page"
        variant="standard"
        title="Next Payment"
      >
        <NextPaymentWrapperError>
          <SAText type="standard" text="Error" />
        </NextPaymentWrapperError>
      </SACard>
    );
  }

  const MakePaymentButton = () => {
    if (isResponsive) {
      return (
        <ResponsiveButtonWrapper>
          <MakePaymentButtonSpacer>
            <Border>
              <SAButton
                fullWidth
                fullWidthUnder={customBase.global.breakpoints.medium}
                test-attr="next-payment-button"
                label="MAKE A PAYMENT"
                variant="primary"
                onClick={() => {
                  if (featureFlagDetails[2]?.flagDetails?.enabled) {
                    setWhichComponent('Making a Payment');
                    setShowOutageModal(true);
                  } else if (paymentInfo?.showDisclaimer.showDisclaimer) {
                    setBaseState(paymentInfo?.showDisclaimer?.baseState);
                    setShowDisclaimerModal(true);
                  } else {
                    makeNextPaymentClick(
                      paymentInfo,
                      accountNumber,
                      awsAppSyncClient,
                      SSOneINCURL?.enabled,
                    );
                    simpleGTMDataLayer({
                      event: 'BillingPayments-MakeAPayment-click',
                      event_action: 'Billing Payments Make A Payment Click',
                      event_category: 'Billing Payments Make A Payment',
                      event_label: 'Billing Payments Make A Payment Click',
                    });
                    simpleGTMDataLayer({
                      event: 'Snowplow-BillingPayments-MakeAPayment-click',
                      event_action:
                        'Snowplow Billing Payments Make A Payment Click',
                      event_category:
                        'Snowplow Billing Payments Make A Payment',
                      event_label:
                        'Snowplow Billing Payments Make A Payment Click',
                    });
                  }
                }}
              />
            </Border>
          </MakePaymentButtonSpacer>
          {featureFlagDetails[0]?.flagDetails?.enabled && (
            <StopPaymentButton
              accountNumber={accountNumber}
              awsAppSyncClient={awsAppSyncClient}
              setHasStoppedPayment={setHasStoppedPayment}
              setShowStopPaymentModal={setShowStopPaymentModal}
              setShowToolTip={setShowToolTip}
              cancelPaymentDisabled={cancelPaymentDisabled}
              setCancelPaymentDisabled={setCancelPaymentDisabled}
              toolTip={toolTip}
              setShowOutageModal={setShowOutageModal}
              setWhichComponent={setWhichComponent}
            />
          )}
        </ResponsiveButtonWrapper>
      );
    }
    return (
      <DesktopButtonWrapper>
        <Border>
          <SAButton
            test-attr="next-payment-button"
            label="MAKE A PAYMENT"
            variant="primary-small"
            onClick={() => {
              if (featureFlagDetails[2]?.flagDetails?.enabled) {
                setWhichComponent('Making a Payment');
                setShowOutageModal(true);
              } else if (paymentInfo?.showDisclaimer?.showDisclaimer) {
                setBaseState(paymentInfo?.showDisclaimer?.baseState);
                setShowDisclaimerModal(true);
              } else {
                makeNextPaymentClick(
                  paymentInfo,
                  accountNumber,
                  awsAppSyncClient,
                  SSOneINCURL?.enabled,
                );
                simpleGTMDataLayer({
                  event: 'BillingPayments-MakeAPayment-click',
                  event_action: 'Billing Payments Make A Payment Click',
                  event_category: 'Billing Payments Make A Payment',
                  event_label: 'Billing Payments Make A Payment Click',
                });
                simpleGTMDataLayer({
                  event: 'Snowplow-BillingPayments-MakeAPayment-click',
                  event_action:
                    'Snowplow Billing Payments Make A Payment Click',
                  event_category: 'Snowplow Billing Payments Make A Payment',
                  event_label: 'Snowplow Billing Payments Make A Payment Click',
                });
              }
            }}
          />
        </Border>
        {featureFlagDetails[0]?.flagDetails?.enabled && (
          <StopPaymentButton
            accountNumber={accountNumber}
            awsAppSyncClient={awsAppSyncClient}
            setHasStoppedPayment={setHasStoppedPayment}
            setShowStopPaymentModal={setShowStopPaymentModal}
            cancelPaymentDisabled={cancelPaymentDisabled}
            setCancelPaymentDisabled={setCancelPaymentDisabled}
            toolTip={toolTip}
            setShowOutageModal={setShowOutageModal}
            setWhichComponent={setWhichComponent}
          />
        )}
      </DesktopButtonWrapper>
    );
  };

  return (
    <SACard
      data-test-id="next-payment-card-billing-page"
      variant="standard"
      title="Next Payment"
      actionLabel="CHANGE DUE DATE"
      actionLabelClickHandler={actionLabelClickHandler}
    >
      {showOutageModal && (
        <OutageModal component={whichComponent} setModal={setShowOutageModal} />
      )}
      {showDisclaimerModal && (
        <MakePaymentModal
          awsAppSyncClient={awsAppSyncClient}
          accountNumber={accountNumber}
          toggleModalDisplay={setShowDisclaimerModal}
          sourceSystemCode={sourceSystemCode}
          isMigrated={isMigrated}
          baseState={baseState}
        />
      )}
      {showChangeDueDateModal && (
        <ChangeDueDateModal
          accountNumber={accountNumber}
          awsAppSyncClient={awsAppSyncClient}
          setShowModal={setShowChangeDueDateModal}
          showPastDue={showPastDue}
          paymentDueDate={paymentInfo?.paymentDueDate}
          cancelPaymentDisabled={cancelPaymentDisabled}
          setReRenderComponentAfterChangedDueDate={
            setReRenderComponentAfterChangedDueDate
          }
        />
      )}
      {showStopPaymentModal && (
        <StopPaymentModalDC
          accountNumber={accountNumber}
          awsAppSyncClient={awsAppSyncClient}
          paymentDueDate={
            paymentInfo?.paymentDueDate
              ? paymentInfo?.paymentDueDate.toString()
              : ''
          }
          setCancelPaymentDisabled={setCancelPaymentDisabled}
          toolTip={toolTip}
          closeOnClickHandler={() => {
            setShowStopPaymentModal(false);
            document.body.style.overflow = 'auto';
          }}
        />
      )}
      {showToolTip && (
        <ResponsiveTooltip toolTip={toolTip} setShowToolTip={setShowToolTip} />
      )}
      <NextPaymentWrapper className="nextPaymentWrapper">
        <AmountAndButtonWrapper>
          <SAText type="heading-3">Next Payment</SAText>
          <AmountDueWrapper>
            <UpcomingPaymentInfo
              paymentInfo={paymentInfo}
              hasStoppedPayment={hasStoppedPayment}
              showPastDue={showPastDue}
              onlyMortgageeBilledInvoices={onlyMortgageeBilledInvoices}
              mortgageeInvoice={mortgageeInvoice}
              showLastDayToPay={
                lastDayToPayInfo?.showLastDayToPay &&
                featureFlagDetails[3]?.flagDetails?.enabled
              }
            />
            <SAText type="small">
              Amount is inclusive of all the policies
            </SAText>
          </AmountDueWrapper>

          {showPastDue && (
            <PastDueIndicator>
              <SATag
                variant="alert"
                withBorder
                label="Past Due"
                startIcon={
                  <SAIcon
                    icon={SAIcons.alert}
                    size="16px"
                    colorVariant="alert"
                  />
                }
              />
            </PastDueIndicator>
          )}
          {lastDayToPayInfo.showLastDayToPay &&
            featureFlagDetails[3]?.flagDetails?.enabled &&
            !showPastDue && <LastDayToPaySpacer />}
          {lastDayToPayInfo.showLastDayToPay &&
            featureFlagDetails[3]?.flagDetails?.enabled && (
              <LastDayToPayText>
                <SAText text="There is a past due amount of " type="small" />
                <SAText
                  text={formatMoney(lastDayToPayInfo?.pastDueAmount) ?? '-'}
                  weight="bold"
                  type="small"
                />
                <SAText
                  text=". The policy(ies) will cancel if the payment is not received on or before "
                  type="small"
                />
                <SAText
                  text={`${formatDate(lastDayToPayInfo?.date, '-')}.`}
                  weight="bold"
                  type="small"
                />
              </LastDayToPayText>
            )}
        </AmountAndButtonWrapper>
        {isResponsive && (
          <MakePaymentButtonWrapper className="makePaymentButtonWrapper">
            <MakePaymentButton />
          </MakePaymentButtonWrapper>
        )}
        <AmountAndButtonWrapper>
          <PastDueCard
            showLastDay={
              lastDayToPayInfo.showLastDayToPay &&
              featureFlagDetails[3]?.flagDetails?.enabled
            }
          >
            {paymentInfo.lastPaymentDate &&
              paymentInfo.lastPaymentAmount &&
              paymentInfo.lastPaymentAmount !== '$0.00' && (
                <LastPaymentWrapper>
                  <SAText type="small" weight="bold">
                    Last Payment {paymentInfo?.lastPaymentAmount}
                  </SAText>
                  <br />
                  <ReceivedOnWrapper>
                    <GreenCheck />
                    <SAText type="small">
                      Received on {paymentInfo?.lastPaymentDate}
                    </SAText>
                  </ReceivedOnWrapper>
                </LastPaymentWrapper>
              )}
          </PastDueCard>
        </AmountAndButtonWrapper>
      </NextPaymentWrapper>
      {!isResponsive && (
        <MakePaymentButtonWrapper className="makePaymentButtonWrapper">
          <MakePaymentButton />
        </MakePaymentButtonWrapper>
      )}
    </SACard>
  );
};

NextPayment.defaultProps = {
  paymentInfo: undefined,
  loading: false,
  error: undefined,
};

export default NextPayment;
